import {
  factory as biLoggerFactory,
  Logger,
} from '@wix/fe-essentials-editor/bi';

let loggerInstance: Logger;

const BI_PLATFORM_HOST_INTEGRATION_ENDPOINT = 'editor-platform';
const BI_PLATFORM_HOST_INTEGRATION_SRC = 164;
export const PLATFORM_INIT = 122;
export const PLATFORM_ERROR = 121;

export function createBiLogger({
  userId,
  metaSiteId,
  editorType,
  editorSessionId,
  sdkInfo,
}: {
  userId: string;
  metaSiteId: string;
  editorSessionId: string;
  editorType?: string;
  sdkInfo?: { sdkVersion?: string };
}) {
  loggerInstance = biLoggerFactory({
    endpoint: BI_PLATFORM_HOST_INTEGRATION_ENDPOINT,
  })
    .updateDefaults({
      src: BI_PLATFORM_HOST_INTEGRATION_SRC,
      msid: metaSiteId,
      uuid: userId,
      esi: editorSessionId,
      sdkVersion: sdkInfo?.sdkVersion,
      editorType,
    })
    .logger();

  return loggerInstance;
}

export function reportBi(evid: number, event: Record<string, any>) {
  if (loggerInstance) {
    const eventParams = { ...event, evid };
    loggerInstance.log(eventParams);
  }
}
